
import login from './stage/login.vue';
import SendCode from './stage/send-code.vue';
import Confirm from './stage/confirm.vue';
import EsiaError from './stage/esia-error.vue';
import { StateEnum } from '../src/State';
import AuthModel from '../src/Model';
import { authApi } from '../src/Api';
import { AuthAppService } from '../src/AuthAppService';

export default {
    components: { EsiaError, Confirm, login, SendCode },
    data() {
        const service = new AuthAppService();
        return {
            service: service,
            state: service.state,
            authModel: service.authModel,
        };
    },
    mounted() {
        const p = new URLSearchParams(location.search);
        if (p.has('service') && p.has('state') && p.has('code')) {
           p.delete('service');
           p.delete('state');
           p.delete('code');

           const newUrl = '?' + p.toString();
           window.history.pushState({ path: newUrl }, '', newUrl);
        }
    },
    methods: {
        onLoginNext(model: AuthModel): void {
            this.authModel = model;
            this.state.next();
        },
        onSendCodeBack() {
            this.state.back();
        },
        async onSendCodeNext(model: AuthModel): Promise<void> {
            if (!model.isConfirmed) {
                this.state.state = StateEnum.CONFIRM;
            } else {
                await authApi.goHome();
            }
        },
        async onConfirmSend(model: AuthModel): Promise<void> {
            if (model.isConfirmed) {
                await authApi.goHome();
            }
        },
        onCancel() {
            this.state.start();
        }
    },
};
